/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AviPermissionResource } from 'generated-types';
import { TechSupportProfileItem } from 'ng/modules/items/factories';

export type TTechSupportProfileCollection = typeof TechSupportProfileCollection;

/**
 * @description Tech Support Profile collection
 * @author Dnyaneshwar Jadhav
 */
export class TechSupportProfileCollection extends Collection {
    public static ngDependencies = [
        TechSupportProfileItem,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'techsupportprofile',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_TECHSUPPORTPROFILE,
            ...args,
        };

        super(extendedArgs);
        this.itemClass_ = this.getNgDependency(TechSupportProfileItem);
    }
}
